import { useRef } from 'react';

export function useStable<T>(fn: () => T, dependencies: unknown[]): T {
  const valueRef = useRef<T | undefined>(undefined);
  const dependencyRef = useRef<unknown[] | undefined>(undefined);

  const { current: previous } = dependencyRef;
  if (
    previous?.length !== dependencies.length ||
    dependencies.some((dep, i) => dep !== previous[i])
  ) {
    dependencyRef.current = dependencies;
    valueRef.current = fn();
  }

  return valueRef.current as T;
}
